import { Scoped } from '@visiba/instantiation';
import { LicenceHolderService } from '@services/licence_holder.service';
import { IdpUrlRedirectStorageService } from '@src/application/idp_url_redirect_storage.service';
import { appendSearchParamToAnyString } from '@cortex-shim/append_search_param_to_any_string';

@Scoped()
export class SignInController {
	constructor(
		private readonly licenceHolderService: LicenceHolderService,
		private readonly idpUrlRedirectStorageService: IdpUrlRedirectStorageService,
	) {
		// Empty
	}

	public selectMethod() {
		let normalizeReturnUrl = this.idpUrlRedirectStorageService.idpUrlRedirectStorage ?? this.licenceHolderService.alias;
		if (normalizeReturnUrl[0] === '/') {
			normalizeReturnUrl = normalizeReturnUrl.slice(1);
		}

		const returnUrl = appendSearchParamToAnyString(normalizeReturnUrl, 'openInApp', 'false');

		return returnUrl;
	}
}
